export const AWSConfiguration = {
  Region: process.env.Region as string,
  IdentityPoolId: process.env.IdentityPoolId as string,
  ApiBaseUrl: process.env.RestApiAddress as string,
  UserPoolId: process.env.UserPoolId as string,
  ClientId: process.env.UserPoolClientId as string,
  AppWebDomain: process.env.AppWebDomain as string,
  TokenScopesArray: ["email", "openid"],
};
